import { startInitAppDebugOverlay } from '@niarab2c/frontend-commons/src/util/initAppDebugOverlay';
import { emitInitAppDebugEvent } from '@niarab2c/frontend-commons/src/util/initAppDebugEvents';
startInitAppDebugOverlay();
emitInitAppDebugEvent('index0:loaded', 'ok');
import(/* webpackChunkName: "index1" */'./index1');